
import { defineComponent, reactive, ref, onMounted } from 'vue';
import { useCoupon } from '@/compositions/useCoupon';
import { StateChanger } from 'vue-infinite-loading';

type Props = { couponIds: string | string[]; filterShopIds: string[] };
type Shop = { id: string; name: string };

/**
 * クーポン対象店舗一覧
 */
export default defineComponent<Props, any>({
  name: 'DialogSelectCouponAvailableShop',

  props: {
    couponIds: {
      type: [String, Array],
      required: true,
    },
    filterShopIds: {
      type: Array,
      default: () => [],
    },
  },

  setup(props: Props, { emit }) {
    const { getAvailableShops } = useCoupon();

    const state = reactive<{ dialog: boolean; from: number; limit: number; selected: Shop | null }>({
      dialog: false,
      // for pagination
      from: 0,
      limit: 50, // パフォーマンス次第で調整
      //
      selected: null,
    });

    const shops = ref<Shop[]>([]);
    const loading = ref(false);

    const infiniteHandler = async ($state: StateChanger) => {
      loading.value = true;
      try {
        const { shops: _shops } = await getAvailableShops(props.couponIds, state.from, state.limit);
        if (_shops.length) {
          state.from += _shops.length;
          const filteredShops = _shops.filter(shop =>
            props.filterShopIds.length <= 0 ? true : props.filterShopIds.includes(shop.id)
          );
          shops.value.push(...filteredShops);
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (e) {
        $state.error();
        throw e;
      } finally {
        loading.value = false;
      }
    };

    const select = (shop: Shop) => {
      if (loading.value) return;
      // ローディング中は無効
      state.selected = shop;
      state.dialog = false;
      emit('select', shop);
    };

    // 初期描画時に最初のページを読み込む
    onMounted(async () => {
      loading.value = true;
      try {
        const { shops: _shops } = await getAvailableShops(props.couponIds, state.from, state.limit);
        if (_shops.length) {
          state.from += _shops.length;
          const filtered = _shops.filter(shop =>
            props.filterShopIds.length <= 0 ? true : props.filterShopIds.includes(shop.id)
          );
          shops.value.push(...filtered);
        }
      } catch (e) {
        console.error(e);
      } finally {
        loading.value = false;
      }
    });

    return {
      state,
      shops,
      loading,
      infiniteHandler,
      select,
    };
  },
});
